<div #filling></div>

<nav #navbar id="navbar" class="navbar navbar-expand-lg bg-guuk">
    <div class="container">
        <!-- Marca -->
        <a class="navbar-brand" routerLink="guuk">
            <img src="../../../../assets/img/logo-guuk.svg" class="img-fluid icon-nav2" height="30">
        </a>

        <div class="navbar-nav align-items-center me-auto" [ngSwitch]="href">
            <span class="navbar-text contratacion" *ngSwitchCase="'/guuk/listado'">
                Listado de operaciones
            </span>
        </div>

        <div class="my-2 my-lg-0">
            <a routerLink="/" *ngIf="!href.includes('/guuk/order')" class="btn btn-white btn-sm">
                Volver al inicio
            </a>
            <a routerLink="/guuk/listado" *ngIf="href.includes('/guuk/order')" class="btn btn-white btn-sm">
                Volver al listado
            </a>
        </div>
    </div>
</nav>
